<section class="layout-pt-lg layout-pb-lg bg-blue-2">
  <div class="container">
    <div class="row justify-center text-center">
      <div class="col-auto">
        <div class="sectionTitle -md">
          <h2 class="sectionTitle__title">Neden Pusula Tatil?</h2>
        </div>
      </div>
    </div>

    <div class="row y-gap-40 justify-between pt-50">

      <div class="col-lg-3 col-sm-6">
        <div class="featureIcon -type-1">
          <div class="d-flex justify-center">
            <svg width="60" height="60" viewBox="0 0 24 24" fill="none" class="text-blue-1" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2l2.83 6.62 7.17.62-5.45 4.73 1.63 7.03L12 17.27 5.82 21l1.63-7.03L2 9.24l7.17-.62L12 2z" stroke="currentColor" stroke-width="2" fill="none" stroke-linejoin="round"/>
            </svg>
          </div>

          <div class="text-center mt-30">
            <h4 class="text-18 fw-500">En İyi Hizmet Garantisi</h4>
            <p class="text-15 mt-10">Pusula Tatil, ihtiyaçlarına en uygun tatili bulman için en doğru seçenekleri sunar.</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-sm-6">
        <div class="featureIcon -type-1">
          <div class="d-flex justify-center">
            <i class="icon-newsletter text-60 text-blue-1"></i>
          </div>

          <div class="text-center mt-30">
            <h4 class="text-18 fw-500">Kolay ve Hızlı Rezervasyon</h4>
            <p class="text-15 mt-10">Pusula Tatil, kolay ve hızlı rezervasyon sürecini müşterilerimize sunarak onların işlerini kolaylaştırır.</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-sm-6">
        <div class="featureIcon -type-1">
          <div class="d-flex justify-center">
            <i class="icon-customer text-60 text-blue-1"></i>
          </div>

          <div class="text-center mt-30">
            <h4 class="text-18 fw-500">7/24 Müşteri Desteği</h4>
            <p class="text-15 mt-10">Pusula Tatil, müşterilerimize 24 saatlik destek hizmeti sunarak onların ihtiyaçlarına hızlıca yanıt verir.</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
